/**
 * Bulk-accept eligibility filter (BUG-008 residual fix).
 *
 * PRD §4 floor rule 2: review-flagged answers (LLM fallback, gap language,
 * missing data) can NEVER be bulk-accepted by a confidence threshold alone.
 * The backend guarantees `requires_review=true` whenever failure reasons
 * exist; we also check `failure_reasons` directly as belt-and-suspenders.
 */

export interface BulkAcceptCandidate {
  question_id: string;
  confidence: number;
  requires_review: boolean;
  userAction?: string;
  failure_reasons?: string[];
}

/**
 * A question may bulk-accept only when it is still pending, carries no
 * review flag and no failure reasons, and meets the confidence threshold.
 */
export function isBulkAcceptEligible(question: BulkAcceptCandidate, threshold: number): boolean {
  const isPending = !question.userAction || question.userAction === 'Pending';
  const isFlagged =
    question.requires_review === true || (question.failure_reasons?.length ?? 0) > 0;
  return isPending && !isFlagged && question.confidence >= threshold;
}
